export interface NavItem {
    path: string;
    label: string;
}

/**
 * The site index, shared by the navbar and the footer so the two cannot
 * drift apart.
 *
 * `home` is deliberately absent: the wordmark is the home link in both
 * places, and listing it as well produced two targets for one destination.
 */
export const NAV_ITEMS: NavItem[] = [
    { path: '/collages', label: 'collages' },
    { path: '/books', label: 'library' },
    { path: '/diary', label: 'diary' },
    { path: '/statement', label: 'statement' },
    // This page existed as a route but nothing linked to it, so the only
    // way to reach it was to type the URL.
    { path: '/static-noise', label: 'noise' }
];
